import React from 'react';

/**
 * Footer component displaying company branding and version information
 * Shown at the bottom of all pages except login
 */
export const Footer: React.FC = () => {
  return (
    <footer className="py-3 px-6 mt-8">
      <div className="text-center md:text-right">
        <p className="text-xs text-gray-400">
          Powered by <span className="text-gray-500">Terretech Nusantara</span> © 2025 - 
          <span className="text-gray-500">2.2.3 Beta</span>
        </p>
      </div>
    </footer>
  );
};
